const rows = document.querySelectorAll(".forminator-row");
if (rows) {
  rows.forEach((row) => {
    const id = row.childNodes[0].id;
    if (id === "phone-1" || id === "email-1") {
      row.classList.add("contactForm__half");
    }
  });
}
